module.exports = __webpack_public_path__ + "img/app_icon.56651cd8.png";